// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__1AOoV","loader__text":"loader_loader__text__f-itq"};